<template>
    <div>
      <canvas ref="canvas"></canvas>
    </div>
  </template>

  <script>
  import Chart from 'chart.js'

  export default {
    name: "RadarChart",
    props: {
  values: {
    type: Array,
    required: true
  },
  labels: {
    type: Array,
    default: () => []
  },
  normalize: {
    type: Boolean,
    default: false
  }
},
    mounted() {
      this.renderChart()
    },
    watch: {
      values() {
        this.renderChart()
      }
    },
    methods: {
      renderChart() {
  if (this.chart) this.chart.destroy()

  const ctx = this.$refs.canvas.getContext('2d')

  const getName = (item, idx) => {
    if (Array.isArray(this.labels) && this.labels.length === this.values.length) {
      return String(this.labels[idx])
    }
    const raw =
      (item && item.label            != null ? item.label :
       item && item.name             != null ? item.name  :
       item && item.cluster          != null ? item.cluster :
       item && item.clase            != null ? item.clase :
       item && item.nombreCluster    != null ? item.nombreCluster :
       item && item.NombreCluster    != null ? item.NombreCluster :
       item && item.NombreClase      != null ? item.NombreClase :
       item && item.nombreClase      != null ? item.nombreClase :
       (item && item.numeroCluster   != null ? `Cluster ${item.numeroCluster}` :
        `Cluster ${idx + 1}`))
    return String(raw).trim()
  }

  const getValue = (item) => {
    const v =
      (item && item.valor  != null ? item.valor  :
       item && item.value  != null ? item.value  :
       item && item.total  != null ? item.total  :
       item && item.monto  != null ? item.monto  :
       0)
    const num = Number(v)
    return Number.isFinite(num) ? num : 0
  }

  // Build pairs, sort descending, take top 20
  const pairs = this.values.map((it, i) => ({
    label: getName(it, i),
    value: getValue(it)
  }))
  pairs.sort((a, b) => b.value - a.value)
  const top20 = pairs.slice(0, 20)

  const labels = top20.map(p => p.label)
  let data = top20.map(p => p.value)

  if (this.normalize && data.length) {
    const max = Math.max(...data, 1)
    data = data.map(v => v / max)
  }

  this.chart = new Chart(ctx, {
    type: 'bar',
    data: {
      labels,
      datasets: [
        {
          label: 'Valores por Cluster',
          backgroundColor: 'rgba(54, 162, 235, 0.6)',
          borderColor: 'rgba(54, 162, 235, 1)',
          borderWidth: 1,
          data
        }
      ]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: { position: 'top' },
      scales: {
        xAxes: [{
          ticks: {
            autoSkip: false,
            maxRotation: 45,
            minRotation: 30
          }
        }],
        yAxes: [{
          ticks: {
            beginAtZero: true,
            callback: value => {
              if (this.normalize) return value
              return `$${Number(value).toLocaleString('en-US', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
              })}`
            }
          }
        }]
      },
      tooltips: {
        callbacks: {
          label: (tooltipItem, dataCfg) => {
            const datasetLabel = dataCfg.datasets[tooltipItem.datasetIndex].label || ''
            const val = tooltipItem.yLabel
            if (this.normalize) return `${datasetLabel}: ${val}`
            const formatted = Number(val).toLocaleString('en-US', {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            })
            return `${datasetLabel}: $${formatted}`
          },
          title: (tooltipItems, dataCfg) => dataCfg.labels[tooltipItems[0].index]
        }
      }
    }
  })
}
    }
  }
  </script>

  <style scoped>
  canvas {
    width: 100% !important;
    height: 400px !important;
  }
  </style>
